/* eslint-disable @typescript-eslint/no-extra-semi */
import axios, { InternalAxiosRequestConfig, AxiosHeaders, AxiosResponse } from 'axios'
import router from '@/router'
import authService from '@/services/auth'

const onRequest = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  if (authService.isAuthenticated()) {
    ;(config.headers as AxiosHeaders).set('Authorization-Medico', `Bearer ${authService.getToken()}`)
  }
  return config
}

const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response
}

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
axios.interceptors.request.use(onRequest)
axios.interceptors.response.use(onResponse, error => {
  if (error.response?.status === 401 && router.currentRoute.name !== 'login') {
    // Caso seja login médico, apaga o token expirado
    authService.logout()
    router.push({ name: 'login' })
  }
  console.error(error)
  return Promise.reject(error)
})
